(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky =
      this.getAttribute('data-sticky-type') === 'always' ||
      this.getAttribute('data-sticky-type') === 'reduce-logo-size';

    this.headerBounds = {};
    this.currentScrollTop = 0;
    this.preventReveal = false;

    this.setHeaderHeight();

    window.matchMedia('(max-width: 990px)')
      .addEventListener('change', this.setHeaderHeight.bind(this));

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    }

    this.onScrollHandler = this.onScroll.bind(this);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  setHeaderHeight() {
    const height = this.header.offsetHeight;
    document.documentElement.style.setProperty('--pf-header-height', height + 'px');
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    const observer = new IntersectionObserver((entries) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.hide();
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.reveal();
    } else if (scrollTop <= this.headerBounds.top) {
      this.reset();
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove(
      'shopify-section-header-hidden',
      'shopify-section-header-sticky',
      'animate'
    );
  }
}


customElements.define('sticky-header', StickyHeader);

function syncPfMenuWithHeader() {
  const header = document.querySelector('.section-header');
  if (!header) return;

  const height = header.getBoundingClientRect().height;
  document.documentElement.style.setProperty(
    '--pf-header-height',
    height + 'px'
  );
}

syncPfMenuWithHeader();
window.addEventListener('resize', syncPfMenuWithHeader);
window.addEventListener('scroll', syncPfMenuWithHeader);


// FIXED: Proper menu toggle functionality
document.addEventListener("DOMContentLoaded", function () {
  const menu = document.getElementById("pf-menu");
  const overlay = document.getElementById("pf-overlay");
  const menuBtn = document.getElementById("pf-menu-btn");

  if (!menu || !overlay || !menuBtn) return;

  function openMenu() {
    menu.classList.add("active");
    overlay.classList.add("active");
    document.body.classList.add("pf-menu-open");
    menuBtn.classList.add("active");
    menuBtn.setAttribute("aria-expanded", "true");
    menu.setAttribute("aria-hidden", "false");
  }

  function closeMenu() {
    menu.classList.remove("active");
    overlay.classList.remove("active");
    document.body.classList.remove("pf-menu-open");
    menuBtn.classList.remove("active");
    menuBtn.setAttribute("aria-expanded", "false");
    menu.setAttribute("aria-hidden", "true");
  }

  // Toggle menu on button click
  menuBtn.addEventListener("click", function (e) {
    e.stopPropagation();
    menu.classList.contains("active") ? closeMenu() : openMenu();
  });

  // Close menu on overlay click
  overlay.addEventListener("click", closeMenu);
  
  // Close menu on ESC key
  document.addEventListener("keydown", function(e) {
    if (e.key === "Escape" && menu.classList.contains("active")) {
      closeMenu();
    }
  });
});


// Accordion functionality
document.querySelectorAll(".pf-accordion-toggle").forEach(toggle => {
  toggle.addEventListener("click", () => {
    const expanded = toggle.getAttribute("aria-expanded") === "true";
    const content = toggle.closest(".pf-accordion").querySelector(".pf-accordion-content");

    toggle.setAttribute("aria-expanded", !expanded);

    if (!expanded) {
      content.style.maxHeight = content.scrollHeight + "px";
    } else {
      content.style.maxHeight = null;
    }
  });
});

// Capture-phase, delegated on document — guaranteed to fire before any
// other script's click handler on the link itself (e.g. a scroll-to-section
// script on the homepage sections), so the menu always closes on tap.
document.addEventListener("click", function (e) {
  const link = e.target.closest('#pf-menu a');
  if (!link) return;

  const menu = document.getElementById("pf-menu");
  const overlay = document.getElementById("pf-overlay");
  const menuBtn = document.getElementById("pf-menu-btn");

  if (!menu || !overlay || !menuBtn) return;

  menu.classList.remove("active");
  overlay.classList.remove("active");
  document.body.classList.remove("pf-menu-open");

  menuBtn.classList.remove("active");
  menuBtn.setAttribute("aria-expanded", "false");
  menu.setAttribute("aria-hidden", "true");
}, true);

// ================================
// 🌟 IMPROVED PRODUCT SEARCH
// ================================
document.addEventListener("DOMContentLoaded", () => {
  const input = document.querySelector('.predictive-search__input');
  const results = document.querySelector('.predictive-search__results');

  if (!input || !results) return;

  let controller;

  input.addEventListener("input", async (e) => {
    const query = e.target.value.trim();
    if (query.length < 2) {
      results.innerHTML = '';
      return;
    }

    controller?.abort();
    controller = new AbortController();

    try {
      const res = await fetch(
        `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=10`,
        { signal: controller.signal }
      );
      const data = await res.json();
      renderProductResults(data, query);
    } catch (_) {}
  });

  function renderProductResults(data, query) {
    const products = data.resources.results.products || [];

    let html = '';

    if (products.length) {
      html += `<div class="predictive-search__products-grid">`;
      
      products.forEach(p => {
        const imageUrl = p.image ? p.image : '';
        const price = p.price ? (p.price / 100).toFixed(2) : '';
        
        html += `
          <a class="predictive-search__product-item" href="${p.url}">
            ${imageUrl ? `<img src="${imageUrl}" alt="${p.title}" class="predictive-search__product-image" loading="lazy">` : ''}
            <div class="predictive-search__product-info">
              <span class="predictive-search__product-title">
                ${highlight(p.title, query)}
              </span>
              ${price ? `<span class="predictive-search__product-price">₹${price}</span>` : ''}
            </div>
          </a>
        `;
      });
      
      html += `</div>`;
    } else {
      html = `<div class="predictive-search__no-results">No products found for "${query}"</div>`;
    }

    results.innerHTML = html;
  }

  function highlight(text, q) {
    return text.replace(
      new RegExp(`(${q})`, 'ig'),
      '<strong>$1</strong>'
    );
  }
});

document.addEventListener("click", (e) => {
  if (e.target.closest('.header__icon--search')) {
    document.body.classList.add('search-open');
  }

  if (e.target.closest('.search-modal__close-button')) {
    document.body.classList.remove('search-open');
  }
});

// ================================
// 🛒 CART DRAWER
// ================================
document.addEventListener("DOMContentLoaded", () => {
  const cartBtn = document.getElementById("cart-icon-bubble");
  const drawer = document.getElementById("pf-cart-drawer");
  const overlay = document.getElementById("pf-cart-overlay");
  const closeBtn = document.getElementById("pf-cart-close");
  const continueBtn = document.getElementById("pf-cart-continue");
  const itemsEl = document.getElementById("pf-cart-items");
  const emptyEl = document.getElementById("pf-cart-empty");
  const loadingEl = document.getElementById("pf-cart-loading");
  const recommendEl = document.getElementById("pf-cart-recommend");
  const footerEl = document.getElementById("pf-cart-footer");
  const originalTotalEl = document.getElementById("pf-cart-original-total");
  const discountRowEl = document.getElementById("pf-cart-discount-row");
  const discountAmountEl = document.getElementById("pf-cart-discount-amount");
  const payableAmountEl = document.getElementById("pf-cart-payable-amount");
  const milestoneEl = document.getElementById("pf-cart-milestone");
  const milestoneMessageEl = document.getElementById("pf-cart-milestone-message");
  const milestoneEyebrowEl = document.getElementById("pf-cart-milestone-eyebrow");
  const milestoneIconEl = document.getElementById("pf-cart-milestone-icon");
  const milestoneFillEl = document.getElementById("pf-cart-milestone-fill");

  const freeShippingEl = document.getElementById("pf-free-shipping");
  const freeShippingMessageEl = document.getElementById("pf-free-shipping-message");
  const FREE_SHIPPING_AMOUNT = 60000; // ₹600 in paise

  const MILESTONE_AMOUNT = 100000; // ₹1,000 in paise
  let previousCartTotal = null;
  let hasCelebratedUnlockedState = false;

  if (!cartBtn || !drawer) return;

  function formatMoney(cents) {
    return "₹" + (cents / 100).toFixed(2);
  }

  function launchCartCelebration() {
    const oldCelebration = drawer.querySelector(".pf-cart-celebration");
    if (oldCelebration) oldCelebration.remove();

    const celebration = document.createElement("div");
    celebration.className = "pf-cart-celebration";
    celebration.setAttribute("aria-hidden", "true");

    const colors = ["#3F0D40", "#7A1D79", "#F4B942", "#FF6B6B", "#2EA44F", "#FFFFFF"];

    for (let i = 0; i < 54; i++) {
      const piece = document.createElement("i");
      const angle = (Math.PI * 2 * i) / 54 + (Math.random() * .5);
      const distance = 130 + Math.random() * 260;
      const x = Math.cos(angle) * distance;
      const y = Math.sin(angle) * distance - 35 + (Math.random() * 100);

      piece.className = "pf-cart-confetti";
      piece.style.setProperty("--x", `${x}px`);
      piece.style.setProperty("--y", `${y}px`);
      piece.style.setProperty("--r", `${Math.floor(Math.random() * 900 - 450)}deg`);
      piece.style.setProperty("--delay", `${Math.random() * .2}s`);
      piece.style.setProperty("--confetti-color", colors[i % colors.length]);
      celebration.appendChild(piece);
    }

    [[18,22],[76,18],[24,58],[81,54]].forEach(([left, top], index) => {
      const spark = document.createElement("b");
      spark.className = "pf-cart-firework";
      spark.style.left = `${left}%`;
      spark.style.top = `${top}%`;
      spark.style.setProperty("--delay", `${index * .12}s`);
      celebration.appendChild(spark);
    });

    drawer.appendChild(celebration);
    window.setTimeout(() => celebration.remove(), 1900);
  }


  function updateFreeShipping(total) {
    if (!freeShippingEl || !freeShippingMessageEl) return;

    const progress = Math.min((total / FREE_SHIPPING_AMOUNT) * 100, 100);
    const unlocked = total >= FREE_SHIPPING_AMOUNT;
    const remaining = Math.max(FREE_SHIPPING_AMOUNT - total, 0);

    freeShippingEl.style.setProperty("--shipping-progress", `${progress}%`);
    freeShippingEl.classList.toggle("is-unlocked", unlocked);

    if (unlocked) {
      freeShippingMessageEl.innerHTML =
        `<strong>Free shipping unlocked</strong> on this order`;
    } else {
      freeShippingMessageEl.innerHTML =
        `Add <strong>${formatMoney(remaining)}</strong> more for free shipping`;
    }
  }

  function updateMilestone(total) {
    if (!milestoneEl) return;

    const progress = Math.min((total / MILESTONE_AMOUNT) * 100, 100);
    const unlocked = total >= MILESTONE_AMOUNT;
    milestoneFillEl.style.width = `${progress}%`;
    milestoneEl.classList.toggle("is-unlocked", unlocked);

    if (unlocked) {
      milestoneEyebrowEl.textContent = "Reward unlocked";
      milestoneIconEl.innerHTML = `
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M12 2.75L14.52 7.86L20.16 8.68L16.08 12.65L17.04 18.26L12 16.02L6.96 18.26L7.92 12.65L3.84 8.68L9.48 7.86L12 2.75Z" fill="#F4C74F"/>
          <path d="M8.55 12.45L10.8 14.7L15.55 9.65" stroke="white" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>`;
      milestoneMessageEl.innerHTML = `<strong>EXTRA 5% OFF UNLOCKED!</strong><br>Your cart has crossed ₹1,000`;
    } else {
      const remaining = MILESTONE_AMOUNT - total;
      milestoneEyebrowEl.textContent = "Almost there";
      milestoneIconEl.innerHTML = `
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M12 2.75L14.52 7.86L20.16 8.68L16.08 12.65L17.04 18.26L12 16.02L6.96 18.26L7.92 12.65L3.84 8.68L9.48 7.86L12 2.75Z" fill="#F4C74F"/>
          <path d="M10.05 13.7L13.95 9.8" stroke="white" stroke-width="1.9" stroke-linecap="round"/>
          <circle cx="9.15" cy="9.35" r="1.05" fill="white"/>
          <circle cx="14.85" cy="14.15" r="1.05" fill="white"/>
        </svg>`;
      milestoneMessageEl.innerHTML = `Add <strong>${formatMoney(remaining)}</strong> more to unlock <strong class="pf-cart-milestone__reward">extra 5% OFF</strong>`;
    }

    // Celebrate as soon as the cart is in the unlocked state. This also makes
    // testing reliable when the drawer opens with a subtotal already above ₹1,000.
    if (unlocked && !hasCelebratedUnlockedState) {
      hasCelebratedUnlockedState = true;
      milestoneEl.classList.remove("is-celebrating");
      void milestoneEl.offsetWidth;
      milestoneEl.classList.add("is-celebrating");
      launchCartCelebration();
      window.setTimeout(() => milestoneEl.classList.remove("is-celebrating"), 1600);
    }

    // Dropping below ₹1,000 resets the celebration for the next unlock.
    if (!unlocked) {
      hasCelebratedUnlockedState = false;
    }

    previousCartTotal = total;
  }

  function openDrawer() {
    drawer.classList.add("active");
    overlay.classList.add("active");
    document.body.classList.add("pf-cart-open");
    drawer.setAttribute("aria-hidden", "false");
    fetchCart();
  }

  function closeDrawer() {
    drawer.classList.remove("active");
    overlay.classList.remove("active");
    document.body.classList.remove("pf-cart-open");
    drawer.setAttribute("aria-hidden", "true");
  }

  async function fetchCart() {
    loadingEl.style.display = "block";
    try {
      const res = await fetch("/cart.js");
      const cart = await res.json();
      renderCart(cart);
    } catch (err) {
      console.error("Cart fetch failed:", err);
    } finally {
      loadingEl.style.display = "none";
    }
  }

  function renderCart(cart) {
    const originalTotal = cart.original_total_price || cart.total_price;
    const payableTotal = cart.total_price;
    const discountAmount = cart.total_discount || Math.max(originalTotal - payableTotal, 0);

    originalTotalEl.textContent = formatMoney(originalTotal);
    payableAmountEl.textContent = formatMoney(payableTotal);

    if (discountAmount > 0) {
      discountRowEl.style.display = "flex";
      discountAmountEl.textContent = "− " + formatMoney(discountAmount);
    } else {
      discountRowEl.style.display = "none";
    }

    updateFreeShipping(originalTotal);
    updateMilestone(originalTotal);

    if (!cart.items.length) {
      itemsEl.style.display = "none";
      emptyEl.style.display = "block";
      footerEl.style.display = "none";
      recommendEl.style.display = "block";
      return;
    }

    emptyEl.style.display = "none";
    itemsEl.style.display = "flex";
    footerEl.style.display = "block";
    recommendEl.style.display = "block";

    itemsEl.innerHTML = cart.items.map(item => `
      <div class="pf-cart-line" data-key="${item.key}">
        <img src="${item.image ? item.image.replace(/(\.[a-zA-Z0-9]+)(\?|$)/, '_100x$1$2') : ''}" alt="${item.product_title}">
        <div class="pf-cart-line-info">
          <span class="pf-cart-line-title">${item.product_title}</span>
          ${item.variant_title ? `<span class="pf-cart-line-variant">${item.variant_title}</span>` : ''}
          <span class="pf-cart-line-price">${formatMoney(item.final_line_price)}</span>
          <div class="pf-cart-qty">
            <button class="pf-cart-qty-minus" data-key="${item.key}" data-qty="${item.quantity - 1}">−</button>
            <span>${item.quantity}</span>
            <button class="pf-cart-qty-plus" data-key="${item.key}" data-qty="${item.quantity + 1}">+</button>
          </div>
          <button class="pf-cart-line-remove" data-key="${item.key}">Remove</button>
        </div>
      </div>
    `).join("");
  }

  async function changeLine(key, quantity) {
    loadingEl.style.display = "block";
    try {
      const res = await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: key, quantity })
      });
      const cart = await res.json();
      renderCart(cart);
      const bubble = document.querySelector('.cart-count-bubble span[aria-hidden="true"]');
      if (bubble) bubble.textContent = cart.item_count;
    } catch (err) {
      console.error("Cart update failed:", err);
    } finally {
      loadingEl.style.display = "none";
    }
  }

  async function addToCart(variantId) {
    loadingEl.style.display = "block";
    try {
      await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      });
      const res = await fetch("/cart.js");
      const cart = await res.json();
      renderCart(cart);
      const bubble = document.querySelector('.cart-count-bubble span[aria-hidden="true"]');
      if (bubble) bubble.textContent = cart.item_count;
    } catch (err) {
      console.error("Add to cart failed:", err);
    } finally {
      loadingEl.style.display = "none";
    }
  }

  cartBtn.addEventListener("click", (e) => {
    e.preventDefault();
    openDrawer();
  });

  closeBtn.addEventListener("click", closeDrawer);
  overlay.addEventListener("click", closeDrawer);
  if (continueBtn) continueBtn.addEventListener("click", closeDrawer);

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && drawer.classList.contains("active")) closeDrawer();
  });

  itemsEl.addEventListener("click", (e) => {
    const minus = e.target.closest(".pf-cart-qty-minus");
    const plus = e.target.closest(".pf-cart-qty-plus");
    const remove = e.target.closest(".pf-cart-line-remove");

    if (minus) {
      const qty = parseInt(minus.dataset.qty, 10);
      changeLine(minus.dataset.key, Math.max(qty, 0));
    } else if (plus) {
      changeLine(plus.dataset.key, parseInt(plus.dataset.qty, 10));
    } else if (remove) {
      changeLine(remove.dataset.key, 0);
    }
  });

  document.getElementById("pf-cart-recommend-grid")?.addEventListener("click", (e) => {
    const addBtn = e.target.closest(".pf-cart-recommend-add");
    if (addBtn) addToCart(addBtn.dataset.variantId);
  });

  // Open custom side cart after returning from Shopify checkout
const urlParams = new URLSearchParams(window.location.search);

if (urlParams.get("open-cart") === "true") {
  openDrawer();

  // Remove the query parameter without refreshing
  const cleanUrl =
    window.location.pathname +
    window.location.hash;

  window.history.replaceState(
    {},
    document.title,
    cleanUrl
  );
}

// Expose so other scripts can open and refresh the drawer
window.pfOpenCartDrawer = openDrawer;
window.pfRenderCartDrawer = renderCart;
});

// ================================
// 🛒 GLOBAL ADD-TO-CART INTERCEPT
// Catches every "Add to cart" form on the site
// (product pages, quick-add, etc.) and routes it
// into the slide-out drawer instead of a full page
// navigation or Dawn's native cart notification.
// ================================
document.addEventListener("submit", async (e) => {
  const form = e.target;
  if (!(form instanceof HTMLFormElement)) return;

  const isAddToCartForm =
    (form.getAttribute("action") || "").includes("/cart/add") ||
    form.querySelector('input[name="id"]');

  if (!isAddToCartForm) return;
  if (e.submitter && e.submitter.name === "checkout") return;

  e.preventDefault();
  e.stopImmediatePropagation();

  const submitBtn = form.querySelector('[type="submit"]');
  if (submitBtn) submitBtn.disabled = true;

  try {
    const formData = new FormData(form);
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { Accept: "application/json" },
      body: formData
    });

    if (!res.ok) {
      const err = await res.json();
      alert(err.description || "Couldn't add item to cart.");
      return;
    }

    if (typeof window.pfOpenCartDrawer === "function") {
      window.pfOpenCartDrawer();
    }

    const cartRes = await fetch("/cart.js");
    const cart = await cartRes.json();
    if (typeof window.pfRenderCartDrawer === "function") {
      window.pfRenderCartDrawer(cart);
    }
    const bubble = document.querySelector('.cart-count-bubble span[aria-hidden="true"]');
    if (bubble) bubble.textContent = cart.item_count;
  } catch (err) {
    console.error("Add to cart failed:", err);
  } finally {
    if (submitBtn) submitBtn.disabled = false;
  }
}, true);


  } catch(e) { console.error(e); }
})();
})();
